import { VEHICLE_BY_PLATE_URL } from '@/constants';
import { UnauthorizedError } from '@/services';
import { HttpStatusCode, fromRiskBff, httpClient } from '@/utils';
import { DeepPartial, FormTruckComposition } from '@/types';
import { parseLoadVehicleByPlate } from './parse-load-vehicle-by-plate';

export const loadVehicleByPlateService = async (plate: string): Promise<DeepPartial<FormTruckComposition>> => {
  const { body, status } = await httpClient.get(fromRiskBff(VEHICLE_BY_PLATE_URL), { params: { plate } });

  switch (status) {
    case HttpStatusCode.ok:
      return parseLoadVehicleByPlate(body?.data);

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    default:
      return parseLoadVehicleByPlate({} as any);
  }
};
